import styled from 'styled-components';

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
  padding: 24px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.landing.cardBg};

  border: 1px solid ${({ theme }) => theme.landing.cardBorder};

  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};

  padding: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  transition: 0.2s;

  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  }
`;

export const IconWrapper = styled.div`
  margin-bottom: 16px;
`;

export const FileName = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  word-break: break-word;
`;

export const Meta = styled.div`
  margin-top: 6px;

  font-size: 12px;

  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 18px;
`;

export const ActionButton = styled.button`
  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;

  border-radius: 8px;

  cursor: pointer;

  background: transparent;

  color: ${({ $danger }) => ($danger ? '#E53935' : 'var(--color-text-secondary)')};

  transition: 0.2s;

  &:hover {
    background: ${({ theme }) => theme.landing.background};
  }
`;

export const EmptyState = styled.div`
  height: 400px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.landing.textSecondary};

  font-size: 15px;
`;
